import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import IconSvg from "../../../../SharedComponents/IconSvg";

const HeroSectionWithText = ({ isImageOnRight, imageSrc, children }) => {
  return (
    <Row className="d-flex justify-content-center mx-0 mt-5">
      <Col
        xs={{ order: 0, span: 11 }}
        md={{ order: isImageOnRight ? 0 : 1, span: 6 }}
        className={"text-12 text-lg-20 align-content-center pb-4"}
      >
        <Row className={"mx-2"}>
          <Col xs={"auto"}>
            {" "}
            <IconSvg icon={"landing-page-bullet"}></IconSvg>
          </Col>
          <Col style={{ color: "#626C77" }}>{children}</Col>
        </Row>
      </Col>
      <Col xs={{ order: 1, span: 11 }} md={{ order: isImageOnRight ? 1 : 0, span: 5 }}>
        <div className={"position-relative"}>
          <Image src={imageSrc} width="100%" alt={"Hero Image"} />
        </div>
      </Col>
    </Row>
  );
};

export default HeroSectionWithText;
